import { render, staticRenderFns } from "./Ferramentas.vue?vue&type=template&id=04102c6d"
import script from "./Ferramentas.vue?vue&type=script&lang=js"
export * from "./Ferramentas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports